import axios from 'axios'
import { push, goBack } from 'react-router-redux'
import {docCookies} from '../../utils/docCookies'
import {ApiHelper, axiosInstance } from '../../utils/ApiHelper'
import {startSubmit, stopSubmit, reset, SubmissionError} from 'redux-form';
import {message} from 'antd';
import {messageSuccess} from '../../utils/AppHelper';

export const REMOVE_MEMBER_REQUEST = 'REMOVE_MEMBER_REQUEST'
export const REMOVE_MEMBER_SUCCESS = 'REMOVE_MEMBER_SUCCESS'
export const REMOVE_MEMBER_FAIL = 'REMOVE_MEMBER_FAIL'

export function removeMemberPrompt(tokenId, email) {
  return {
    type: 'SHOW_MODAL',
    modalType: 'CONFIRM_REMOVE_MODAL',
    modalProps: {
      tokenId, email, group: 'enterprise'
    }
  }
}

export function notifyWithError(err) {
  return {
    type: 'SHOW_MODAL',
    modalType: 'NOTIFY_ERROR_MODAL',
    modalProps: {
      err
    }
  }
}

export function removeMember(tokenId) {
  return dispatch => {
    dispatch({type:REMOVE_MEMBER_REQUEST, tokenId, group: 'enterprise'})
    return axiosInstance.delete('enterprise_groups/members/'+tokenId)
      .then(json => {
        dispatch({type:REMOVE_MEMBER_SUCCESS, tokenId, group: 'enterprise'})
        dispatch(push(`/teams/members`))

        return json
      })
      .catch(ex => dispatch({type:REMOVE_MEMBER_FAIL, tokenId, group: 'enterprise'}) )
  }
}

export const ENTERPRISE_MEMBER_REQUEST = 'ENTERPRISE_MEMBER_REQUEST'
export const ENTERPRISE_MEMBER_SUCCESS = 'ENTERPRISE_MEMBER_SUCCESS'
export const ENTERPRISE_MEMBER_FAILURE = 'ENTERPRISE_MEMBER_FAILURE'

export function getEnterpriseMember(token_id, data = {}) {
  return (dispatch, getState) => {

    dispatch({type:ENTERPRISE_MEMBER_REQUEST, data})
    return ApiHelper.getMember(token_id, data)
    .then(({data, request}) => {
      data.token_id = token_id
      dispatch({type:ENTERPRISE_MEMBER_SUCCESS, selectedMember: data})
    })
    .catch( err => {
      console.log(err);
      dispatch({type:ENTERPRISE_MEMBER_FAILURE, err})
    })
  }
}

export const GET_ENTERPRISE_GROUP_REQUEST = 'GET_ENTERPRISE_GROUP_REQUEST'
export const GET_ENTERPRISE_GROUP_SUCCESS = 'GET_ENTERPRISE_GROUP_SUCCESS'
export const GET_ENTERPRISE_GROUP_FAILURE = 'GET_ENTERPRISE_GROUP_FAILURE'
export function getEnterpriseGroupRequest() {
  return {
    type: GET_ENTERPRISE_GROUP_REQUEST
  }
}
export function getEnterpriseGroupSuccess(json) {
  return {
    type: GET_ENTERPRISE_GROUP_SUCCESS,
    json
  }
}
export function getEnterpriseGroupFailure(err) {
  return {
    type: GET_ENTERPRISE_GROUP_FAILURE,
    err
  }
}

export function getEnterpriseGroup() {
  return dispatch => {
    dispatch(getEnterpriseGroupRequest());

    return ApiHelper.getEnterpriseGroup().then(response => {

      if (response.status != 200) {
      } else {
        dispatch(getEnterpriseGroupSuccess(response.data))
      }

    })
    .catch( err => {
      console.log("getEnterpriseGroup catch error");
      console.log(err);
      dispatch(getEnterpriseGroupFailure(err))
    })

  }
}

export const RESET_CREATE_MEMBER_INVITES_FORM = 'RESET_CREATE_MEMBER_INVITES_FORM'
export const CREATE_MEMBER_INVITES_REQUEST = 'CREATE_MEMBER_INVITES_REQUEST'
export const CREATE_MEMBER_INVITES_SUCCESS = 'CREATE_MEMBER_INVITES_SUCCESS'
export const CREATE_MEMBER_INVITES_FAILURE = 'CREATE_MEMBER_INVITES_FAILURE'
export function resetCreateMemberInvitesForm() {
  return {
    type: RESET_CREATE_MEMBER_INVITES_FORM
  }
}
export function createMemberInvitesRequest() {
  return {
    type: CREATE_MEMBER_INVITES_REQUEST
  }
}
function createMemberInvitesSuccess(json) {
  return {
    type: CREATE_MEMBER_INVITES_SUCCESS,
    json: json,
    receivedAt: Date.now()
  }
}
function createMemberInvitesFailure() {
  return {
    type: CREATE_MEMBER_INVITES_FAILURE,
    receivedAt: Date.now()
  }
}
function showCreateMembersSuccessModal(response) {
  return {
    type: 'SHOW_MODAL',
    modalType: 'INVITED_AND_ADDED_MEMBERS',
    modalProps: {
      group: 'enterprise',
      members: response.data.members ? response.data.members : [],
      invited: response.data.sent_invites ? response.data.sent_invites : []
    }
  }
}
export function createMemberInvites(values) {
  return dispatch => {
    dispatch(startSubmit('AddMemberForm'));
    dispatch(createMemberInvitesRequest());

    // Replace new lines with comma, remove blank spaces, split
    var data = {}
    // TODO shared logic should be selector
    // const splitBatchEmails = value => value.replace(/[\n ,]+/igm,",").split(",")
    data.member_emails = values.emails.toLowerCase().replace(/[\n ,]+/igm,",").split(",")

    return ApiHelper.createMemberInvites(data).then(response => {

      if (response.status != 201) {
        dispatch(createMemberInvitesFailure())
        dispatch(stopSubmit('AddMemberForm'));
      } else {
        dispatch(createMemberInvitesSuccess(response))
        dispatch(showCreateMembersSuccessModal(response))
        // specific for the checkmark animation
        setTimeout(function(){ dispatch(resetCreateMemberInvitesForm()); dispatch(reset('AddMemberForm')); }, 2000)
        dispatch(stopSubmit('AddMemberForm'));
        return response
      }
    })
  }
}



export function resendMemberInvites(values) {
  return dispatch => {
    dispatch({type: "RESEND_MEMBER_INVITES_REQUEST"});

    // Replace new lines with comma, remove blank spaces, split
    var data = {}
    // TODO shared logic should be selector
    // const splitBatchEmails = value => value.replace(/[\n ,]+/igm,",").split(",")
    data.member_emails = values.emails.toLowerCase().replace(/[\n ,]+/igm,",").split(",")

    return ApiHelper.createMemberInvites(data).then(response => {

      if (response.status != 201) {
        dispatch({type: "RESEND_MEMBER_INVITES_FAILURE"})
        return response
      } else {
        dispatch({type: "RESEND_MEMBER_INVITES_SUCCESS"})
        return response
      }
    })
  }
}

export const SEND_DATA_EXPORT_ENTERPRISE_REQUEST = 'SEND_DATA_EXPORT_ENTERPRISE_REQUEST'
export const SEND_DATA_EXPORT_ENTERPRISE_SUCCESS = 'SEND_DATA_EXPORT_ENTERPRISE_SUCCESS'
export const SEND_DATA_EXPORT_ENTERPRISE_FAILURE = 'SEND_DATA_EXPORT_ENTERPRISE_FAILURE'
function sendDataExportEnterpriseRequest() {
  return {
    type: SEND_DATA_EXPORT_ENTERPRISE_REQUEST
  }
}
function sendDataExportEnterpriseSuccess() {
  messageSuccess('Sent data export successfully.', 5)

  return {
    type: SEND_DATA_EXPORT_ENTERPRISE_SUCCESS,
    receivedAt: Date.now()
  }
}
function sendDataExportEnterpriseFailure() {
  return {
    type: SEND_DATA_EXPORT_ENTERPRISE_FAILURE
  }
}
export function sendDataExportEnterprise(token_id, data) {
  return (dispatch, getState) => {

    dispatch(sendDataExportEnterpriseRequest())
    const {selectedDates} = getState().enterprise

    return ApiHelper.sendDataExportEnterprise(token_id, {...data, ...selectedDates}).then(response => {
      dispatch(sendDataExportEnterpriseSuccess())
    }).catch(response=>{
      dispatch(sendDataExportEnterpriseFailure())
    });
  }
}



// WEBPACK FOOTER //
// ./src/enterprise/members/actions.js